/**
 * Where the hotel lives in koomzoapps (kz2 M7): `/provider/app/hotel/…` — the DS's `/hotel/…`
 * (`data/hotel.routes.ts`, `HOTEL_ROUTES`), one routed page per section.
 *
 * Root-light on purpose: `hotel-attention.ts` (in the app's initial chunk) reads `HOTEL_RAIL`, so
 * nothing here may import the store, the records or a page.
 */

export const HOTEL_BASE = '/provider/app/hotel';

/** The twelve sections, each its own page. */
export type HotelSection =
  | 'rooms'
  | 'bookings'
  | 'housekeeping'
  | 'folios'
  | 'guests'
  | 'rates'
  | 'team'
  | 'prearrival'
  | 'long-stay'
  | 'audit'
  | 'reports'
  | 'setup';

export const HOTEL_SECTIONS: readonly HotelSection[] = [
  'rooms',
  'bookings',
  'housekeeping',
  'folios',
  'guests',
  'rates',
  'team',
  'prearrival',
  'long-stay',
  'audit',
  'reports',
  'setup',
];

/** The app's path for each DS section. */
export const HOTEL_PATH = {
  rooms: `${HOTEL_BASE}/rooms`,
  bookings: `${HOTEL_BASE}/bookings`,
  housekeeping: `${HOTEL_BASE}/housekeeping`,
  folios: `${HOTEL_BASE}/folios`,
  guests: `${HOTEL_BASE}/guests`,
  rates: `${HOTEL_BASE}/rates`,
  team: `${HOTEL_BASE}/team`,
  prearrival: `${HOTEL_BASE}/prearrival`,
  longStay: `${HOTEL_BASE}/long-stay`,
  audit: `${HOTEL_BASE}/audit`,
  reports: `${HOTEL_BASE}/reports`,
  setup: `${HOTEL_BASE}/setup`,
  home: `${HOTEL_BASE}/home`,
} as const;

/**
 * The rail items the hotel's badges decorate — the pages-config urls of its children (the DS's
 * badged rows: Bookings, Cleaning, Folios; and Audit, whose stop the desk clears through the day).
 */
export const HOTEL_RAIL = {
  bookings: HOTEL_PATH.bookings,
  housekeeping: HOTEL_PATH.housekeeping,
  folios: HOTEL_PATH.folios,
  audit: HOTEL_PATH.audit,
} as const;
